<template>
  <div>
    <template v-if="showHeader">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row class="mb-8" id="onlineEx-list">
        <v-col class="pt-0">
          <span class="text-tcdc-green header text-uppercase bold">online exhibition</span>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <template v-for="(item, i) of allOnlineExhibitions">
        <v-col cols="12" :md="i === 0 ? 12 : 6" :key="i.toString()">
          <OnlineExhibition
            class="cursor-pointer"
            :image="item.cover_image"
            :title="item[`title_${lang}`]"
            :date="item.publish_date"
            :viewer="item.viewer"
            @click.native="exhibitionHandler(item.id)"
          />
        </v-col>
      </template>
    </v-row>
    <v-row class="mt-5">
      <v-col class="d-flex flex-1 justify-end">
        <v-pagination
                v-if="onlineExhibitionPages"
                v-model="onlineExhibitionPages.current_page"
                :length="onlineExhibitionPages.last_page"
                total-visible="7"
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                color="#2e8037"
                @input="(event) => {changePage(event); $vuetify.goTo('#onlineEx-list');}"
      ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OnlineExhibition from "../../components/cards/ExhibitionCard";
import { mapState } from "vuex";

export default {
  components: {
    OnlineExhibition,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    exhibitionHandler(id) {
      this.$router.push({ name: 'OnlineExhibitionDetail', params: { id: id } });
    },
    changePage(page) {
      this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: page, lang: this.lang });
    }
  },
  created() {
    this.items[0].text = this.branchName;
    if (!this.onlineExhibitionPages) {
      this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang });
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      onlineExhibitionPages: state => state.Article.allOnlineExhibitions,
      allOnlineExhibitions: state => {
        if (state.Article.allOnlineExhibitions) {
          return state.Article.allOnlineExhibitions.data
        }
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
      this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang });
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home"
      },
      {
        text: "SERVICE",
        disabled: false,
        href: "/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/service/resource-center"
      },
      {
        text: "ONLINE EXHIBITION",
        disabled: true
      }
    ],
    exhibitions: [
      {
        id: 1,
        name: "YES, PLASTIC! Things to rethink",
        time: "14 Aug 2019",
        view: "78",
        highlight: true
      },
      {
        id: 2,
        name: "YES, PLASTIC! Things to rethink",
        time: "14 Aug 2019",
        view: "78",
        highlight: false
      },
      {
        id: 3,
        name:
          "YES, PLASTIC! Things to rethink adfgsfghjko iuytgrsdfhuiyo utrggfjgkh asdfadsfas",
        time: "14 Aug 2019",
        view: "78",
        highlight: false
      },
      {
        id: 4,
        name: "YES, PLASTIC! Things to rethink",
        time: "14 Aug 2019",
        view: "78",
        highlight: false
      },
      {
        id: 5,
        name: "YES, PLASTIC! Things to rethink",
        time: "14 Aug 2019",
        view: "78",
        highlight: false
      }
    ]
  })
};
</script>

<style>
</style>
